import { createRef, lazy, memo, RefObject, Suspense, VideoHTMLAttributes } from "react";
import { useVideo } from "./hooks";
import { Player } from "@/components/UI/Player";
import { useExperiment } from "@/common/hooks/useExperiment";
import { EXPERIMENT_USE_CUSTOM_HLS } from "@/common/services/experiment/constants";

const HlsVideo = lazy(() => import("@/components/hls/HlsVideo"));

interface IProps
  extends VideoHTMLAttributes<HTMLVideoElement> {
  videoRef?: RefObject<HTMLVideoElement>;
  onMounted?: () => void;
}

export const Video = memo(({
  src,
  videoRef = createRef<HTMLVideoElement>(),
  ...restProps
}: IProps) => {
  const { isHls } = useVideo({ src });
  const { isLoading, variant: useCustomHls } = useExperiment({ key: EXPERIMENT_USE_CUSTOM_HLS, fallback: false });

  if (isLoading) {
    return null;
  }

  if (useCustomHls) {
    return (
      <>
        <Player videoRef={videoRef} src={src} useHlsEngine={isHls} {...restProps} />
      </>
    );
  }

  return (
    <Suspense>
      <HlsVideo videoRef={videoRef} src={src} useHlsEngine={isHls} {...restProps} />
    </Suspense>
  );
});
